<template>
  <div class="care--page" id="view">
    <hero-section />
    <!-- <main-section /> -->
    <info-section />
    <impact-section />

    <program-section />
    <professional-development-section />
     <!-- <testimonal-section  :hasPB="true" backgroundColor="#DEF3FF"/> -->
    <carousel-section />
  </div>
</template>

<script>
// Global Components
// import HeroSection from "@/components/partials/HeroSection.vue";
import NeuHeaderSektion from './Sections/NeuHeaderSektion.vue';

// Local Components
import CarouselSection from './Sections/CarouselSection.vue';
// import MainSection from "./Sections/MainSection.vue";
import InfoSection from './Sections/InfoSection.vue';
import ProgramsSection from './Sections/ProgramsSection.vue';
import DeveloperStories from '@/views/whySmartworks/forDevelopers/Sections/DeveloperStories.vue';
import ProfessionalDevelopmentSection from './Sections/ProfessionalDevelopmentSection.vue';
import ImpactMeterVue from './Sections/ImpactMeter.vue';

export default {
  components: {
    'hero-section': NeuHeaderSektion,
    'carousel-section': CarouselSection,
    'impact-section' : ImpactMeterVue,

    // "main-section": MainSection,
    'info-section': InfoSection,
    'program-section': ProgramsSection,
     'testimonal-section': DeveloperStories,
    'professional-development-section': ProfessionalDevelopmentSection,
  },
  data: () => ({
    title: 'DIGU Cares',
    subTitle:
      'Creating Opportunities &middot; Changing Lives &middot; Giving Back for a Better Future',
  }),
  created() {
    document.getElementById('loaderSection').classList.add('d-none');
  },
};
</script>
